export default __webpack_public_path__ + "static/media/goback.4440b7ee.svg";